import { useCallback, useState } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getEditorText, getSubjectFieldValidationMessage } from '../../utils/email';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { Flex } from 'foundations-components/components/Flex';
import AILoadingButton from 'ai-components-ui-library/components/buttons/AILoadingButton';
import { EditorState } from 'prosemirror-state';
import { getBodyFieldEditorConfig } from './BodyField';
import { getDocNodeFromHtml } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { getStandaloneTracker } from '../../usage-tracker/standaloneTrack';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SubjectField = ({
  aiGenerateEmailButtonConfig
}) => {
  const {
    subjectValue,
    updateSubjectValue,
    initialSubjectValueLoading,
    bodyValue,
    updateBodyValue,
    selectedToValue,
    selectedFromValue
  } = useEmailShareTabContext();
  const handleChange = useCallback(event => {
    updateSubjectValue(event.target.value);
  }, [updateSubjectValue]);
  const [aiGenerateLoading, setAiGenerateLoading] = useState(false);
  const handleAiGenerateEmailContent = useCallback(() => {
    setAiGenerateLoading(true);
    aiGenerateEmailButtonConfig.generateSubjectAndBody({
      toContact: selectedToValue,
      fromValue: selectedFromValue,
      body: getEditorText(bodyValue),
      subject: subjectValue
    }).then(({
      subject,
      body
    }) => {
      if (subject) {
        updateSubjectValue(subject);
      }
      if (body) {
        updateBodyValue(EditorState.create(Object.assign({
          doc: getDocNodeFromHtml(body)
        }, getBodyFieldEditorConfig(selectedToValue))));
      }
      setAiGenerateLoading(false);
    }).catch(() => {
      setAiGenerateLoading(false);
    });
  }, [aiGenerateEmailButtonConfig, selectedFromValue, selectedToValue, subjectValue, updateBodyValue, updateSubjectValue, bodyValue]);
  const validationMessage = getSubjectFieldValidationMessage(subjectValue);
  function renderLabel() {
    if (aiGenerateEmailButtonConfig && selectedToValue && selectedFromValue) {
      return /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.subjectField.label"
        }), /*#__PURE__*/_jsx(AILoadingButton, {
          onClick: handleAiGenerateEmailContent,
          loading: aiGenerateLoading,
          usageTracker: getStandaloneTracker().clone({
            standalone: false,
            trackerName: 'commerce-tools-ui-lib'
          }),
          tooltip: aiGenerateEmailButtonConfig.tooltipMainText,
          "data-test-id": "buyer-email-ai-generate-button",
          children: aiGenerateEmailButtonConfig.buttonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.aiGenerateEmailButton.label"
          })
        })]
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.subjectField.label"
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: renderLabel(),
    error: !!validationMessage,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "email-share-tab-subject-field",
      disabled: initialSubjectValueLoading,
      value: subjectValue,
      onChange: handleChange,
      placeholder: unescapedText('CommerceToolsUiLib.shareToolModal.emailTab.subjectField.placeholder')
    })
  });
};